export default "__VITE_ASSET__zCOqnyQ8__"